export default __webpack_public_path__ + "static/media/TechWallet.b87949d5.png";